import React, { useState } from 'react'
import TourMainButton from '../TourMainButton/TourMainButton'
import ButtonOne from './Assets/Img/ButtonOne.png'
import ButtonTwo from './Assets/Img/ButtonTwo.png'
import { Link } from 'react-router-dom'

import './Assets/styles.css'


const dataMain = [
  {
    id: 1,
    icon: ButtonOne,
    title: '¿No sabes qué hacer en tu destino?',
    description: 'Dejanos tus datos, te contactaremos con todas las actividades que tiene para ti Wellezy'
  },
  {
    id: 2,
    icon: ButtonTwo,
    title: '¿Ya sabes qué hacer en tu destino?',
    description: 'Habla con un asesor cuentanos a que lugares y que actividades quieres realizar te daremos tu cotización'
  }
]


function TourMain() {

  const [destinityOne, setDestinityOne] = useState(true)
  const [destinityTwo, setDestinityTwo] = useState(false)

  const onClickFunctOne = () => {
    setDestinityOne(true)
    setDestinityTwo(false)
  }
  const onClickFunctTwo = () => {
    setDestinityOne(false)
    setDestinityTwo(true)
  }

  return (
    <div className='tourMain'>
      <div className='tourMain_buttons'>
        <Link to={'https://wa.link/uq1q0p'} target='blank'>
          <TourMainButton mainButtonIcon={dataMain[0].icon} mainButtonTitle={dataMain[0].title} mainButtonDescription={dataMain[0].description} onClickFunct={onClickFunctOne} styled={destinityOne === true ? { border: '3px solid #004274' } : { border: 'none' }} />
        </Link>
        <Link to={'https://wa.link/uq1q0p'} target='blank'>
          <TourMainButton mainButtonIcon={dataMain[1].icon} mainButtonTitle={dataMain[1].title} mainButtonDescription={dataMain[1].description} onClickFunct={onClickFunctTwo} styled={destinityTwo === true ? { border: '3px solid #004274' } : { border: 'none' }} />
        </Link>


      </div>
    </div>
  )
}

export default TourMain